module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icon-team-76cb1422c224d2dd58be7e97c001cfe4.svg";